import './OperationsGuide.css';

import { GuideTarget } from './operationsGuideSections';
import { Link } from 'react-router-dom';
import React from 'react';

interface GuideBannerProps {
  /** Distinguishes one page's banner from another in storage. */
  storageKey: string;
  section: GuideTarget;
  children: React.ReactNode;
}

/**
 * A one-time pointer at the guide for someone seeing a page for the first time.
 *
 * Dismissal is per page and persists in localStorage, so this is a nudge for new
 * users rather than furniture the regulars have to read past every day.
 */
const GuideBanner: React.FC<GuideBannerProps> = ({ storageKey, section, children }) => {
  const key = `providerValidator.guideBanner.${storageKey}`;
  const [dismissed, setDismissed] = React.useState(() => {
    try {
      return localStorage.getItem(key) === 'dismissed';
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(key, 'dismissed');
    } catch {
      // A browser refusing storage should still let the banner close for this visit.
    }
    setDismissed(true);
  };

  return (
    <div className="guide-banner">
      <div className="guide-banner-body">
        {children}{' '}
        <Link to={`/guide#${section}`}>Read the operations guide</Link>.
      </div>
      <button
        type="button"
        className="guide-banner-dismiss"
        onClick={dismiss}
        aria-label="Dismiss this reminder"
        title="Dismiss"
      >
        &times;
      </button>
    </div>
  );
};

export default GuideBanner;
